module.exports = __webpack_public_path__ + "img/instagram-instruction-1.3a0eb97b.png";